import axios from "axios";
import { API_URL } from "@/config";

export default {
  namespaced: true,

  actions: {
    async getMany(_, criteria) {
      const response = await axios.get(`${API_URL}/kitchens`, { params: criteria });

      if (!response.data || typeof response.data !== "object") {
        throw new Error("Error occurred while processing your request.");
      }

      return response.data;
    },

    async getKitchensIngredients(_, criteria) {
      const response = await axios.get(`${API_URL}/kitchens/ingredients`, {
        params: criteria,
      });

      if (!response.data || typeof response.data !== "object") {
        throw new Error("Error occurred while processing your request.");
      }

      return response.data;
    },

    async getOne(_, kitchenId) {
      const response = await axios.get(`${API_URL}/kitchens/${kitchenId}`);

      if (!response.data || typeof response.data !== "object") {
        throw new Error("Error occurred while processing your request.");
      }

      return response.data;
    },

    async create(_, kitchenData) {
      const response = await axios.post(`${API_URL}/kitchens`, kitchenData);

      if (response.status !== 201 || !response.data || typeof response.data.id !== "number") {
        throw new Error("Error occurred while processing your request.");
      }

      return response.data;
    },

    async update(_, { kitchenId, kitchenData }) {
      const response = await axios.put(`${API_URL}/kitchens/${kitchenId}`, kitchenData);

      if (response.status !== 200 || !response.data) {
        throw new Error("Error occurred while processing your request.");
      }

      return response.data;
    },

    async delete(_, kitchenId) {
      const response = await axios.delete(`${API_URL}/kitchens/${kitchenId}`);

      if (response.status !== 200 || !response.data.status) {
        throw new Error("Error occurred while processing your request.");
      }

      return true;
    },

    async getOptions(_, criteria = {}) {
      const response = await axios.get(`${API_URL}/kitchens/options`, { params: criteria });

      if (!response.data || typeof response.data !== "object") {
        throw new Error("Error occurred while processing your request.");
      }

      return response.data;
    },

    async getManyKitchensInstitutionsMealTypes(_, criteria = {}) {
      const response = await axios.get(`${API_URL}/kitchensInstitutionsMealTypes`, {
        params: criteria,
      });

      if (!response.data || typeof response.data !== "object") {
        throw new Error("Error occurred while processing your request.");
      }

      return response.data;
    },

    async getMissingKitchensInstitutionsMealTypes() {
      const response = await axios.get(`${API_URL}/kitchensInstitutionsMealTypes/missing`);

      if (!response.data || typeof response.data !== "object") {
        throw new Error("Error occurred while processing your request.");
      }

      return response.data;
    },

    async getAllKitchensInstitutionsMealTypes() {
      const response = await axios.get(`${API_URL}/kitchensInstitutionsMealTypes/all`);

      if (!response.data || typeof response.data !== "object") {
        throw new Error("Error occurred while processing your request.");
      }

      return response.data;
    },
  },
};
